const aaa = [
	{
		path: "consumables",
		component: () => import("@/views/chanpin/consumables/consumables.vue"),
		meta:{title:'耗材',keepAlive:true},
	},
	{
		path: "addconsumables",
		component: () => import("@/views/chanpin/consumables/addconsumables.vue"),
		meta:{title:'编辑耗材'},
	}
]
export default aaa;